import { render, staticRenderFns } from "./FirmCreateView.vue?vue&type=template&id=7152c069&"
import script from "./FirmCreateView.vue?vue&type=script&lang=js&"
export * from "./FirmCreateView.vue?vue&type=script&lang=js&"
import style0 from "./FirmCreateView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports